import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`My websites look the same`}</h1>
    <p>{`If you look at the sites I make in chronological order, many are fairly similar to one another. I’ll use the same tech stack & sometimes aesthetics for several sites in a row (examples from this summer: `}<a parentName="p" {...{
        "href": "https://co2.now.sh"
      }}>{`CO2`}</a>{` → `}<a parentName="p" {...{
        "href": "https://hackclub-emoji.now.sh"
      }}>{`hackclub-emoji`}</a>{`, `}<a parentName="p" {...{
        "href": "https://hackpenn.com"
      }}>{`Hack Pennsylvania recap`}</a>{` → `}<a parentName="p" {...{
        "href": "https://lachlanjc.me"
      }}>{`personal site`}</a>{`, `}<a parentName="p" {...{
        "href": "https://notebook.lachlanjc.me"
      }}>{`Notebook`}</a>{` → `}<a parentName="p" {...{
        "href": "https://ima.lachlanjc.me"
      }}>{`IMA`}</a>{`). They’re `}<a parentName="p" {...{
        "href": "https://jxnblk.com/blog/iterations-on-a-theme/"
      }}>{`Iterations on a Theme`}</a>{`, one might say.`}</p>
    <p>{`I am a designer, not an artist. My sites are not artwork for a gallery, they are designed with a specific purpose & goal in mind. Each one is for a different audience—if the `}<a parentName="p" {...{
        "href": "https://windyhacks.com"
      }}>{`Windy City Hacks`}</a>{` site shares a lot with `}<a parentName="p" {...{
        "href": "https://hackpenn.com"
      }}>{`Hack Pennsylvania`}</a>{`, so be it. The goal of those sites is getting high schoolers hundreds of miles from one another to sign up for an event, & they don’t care about the design. As such, making each site totally unique is not a priority for me.`}</p>
    <p>{`This is partly because I rarely start sites’ code from scratch. Each site is for express purpose of communicating information, & making them quickly & pretty “feature-complete” (design system/theme/reusable components, social cards/metadata, dark mode, server-rendering, basic accessibility, etc) is often important. The Windy website was forked from the Penn website which was forked from the `}<a parentName="p" {...{
        "href": "https://hackhappyvalley.com"
      }}>{`Hack Happy Valley`}</a>{` website which borrowed components from `}<a parentName="p" {...{
        "href": "https://hackclub.com"
      }}>{`Hack Club`}</a>{`.`}</p>
    <p>{`I make myself `}<a parentName="p" {...{
        "href": "https://github.com/lachlanjc/next-mdx-rebass-theme-ui"
      }}>{`starter templates`}</a>{`, & often just clone or remix a previous site (I code mostly on `}<a parentName="p" {...{
        "href": "https://glitch.com"
      }}>{`Glitch`}</a>{` these days! from my iPad). For small ideas, giving myself an easier jumping off point is often critical to making the project happen—depending on how important a project is (Hack Penn: mission-critical, hackclub-emoji: throwaway idea), if I had to start from scratch every time, the small ideas would never happen.`}</p>
    <p>{`I’m not ashamed of making websites that look the same, & I don’t think you should either. If the websites are making the web & world a better place, making more of them faster is just clearly better. No one cares if each one I started from scratch.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      